import type { GatewayAssetOut } from "kubb";

import type React from "react";
import { Heading } from "../../../../components/Theme/heading";
import DisplayIfUserType from "../../../../components/utils/DisplayIfUserType/DisplayIfUserType";
import JobCreateForm from "../../../../containers/jobs/JobCreateForm";
import JobList from "../../../../containers/jobs/JobList";

const GatewayJobTab = (props: {
  gateway: GatewayAssetOut;
}): React.ReactElement => {
  const gatewayPosition = props.gateway.asset_position_id;

  return (
    <>
      {gatewayPosition ? (
        <>
          <Heading>Scheduled Jobs</Heading>
          <JobList
            asset_position_id={gatewayPosition}
            company_id={props.gateway.company_id}
          />
          <DisplayIfUserType userTypes={"admin"}>
            <Heading>Add New Job</Heading>
            <JobCreateForm
              asset_position_id={gatewayPosition}
              company_id={props.gateway.company_id}
            />
          </DisplayIfUserType>
        </>
      ) : (
        <>
          <Heading>Scheduled Jobs</Heading>
          <p>
            This gateway is not assigned to a position. No jobs are supported.
          </p>
        </>
      )}
    </>
  );
};

export default GatewayJobTab;
